import React, { FC, ReactElement, useEffect, useState } from "react";

import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

import { Button, Grid, Typography } from "@mui/material";

import accessdenied from "../assets/accessdenied.svg";

import apiCall from "../utils/apiCall";
import { GET_REQUEST, RAISE_REQUEST } from "../endpoint";
import { PENDING } from "../data/constants";

import { useAppSelector, useAppDispatch } from "../hooks/reduxhook";
import { getuser } from "../redux/slices/userSlice";
import { addError } from "../redux/slices/errorSlice";
const NoAccess: FC<any> = (): ReactElement => {
  const dispatch = useAppDispatch()
  const { accounts } = useMsal();
  const account = accounts[0];

  const [sentReq, setSentReq] = useState(false);

  const user = useAppSelector(getuser);
  const navigate = useNavigate();

  useEffect(() => {
    apiCall("POST", GET_REQUEST, {
      user_email: account.username,
    })
      .then((res) => {
        if (res.result === "pending") {
          setSentReq(true);
        } else if (res.result === "approved") {
          navigate("/");
        }
      })
      .catch((err) => {
        dispatch(addError("Failed to load the requests.Please try again."))
      });
  }, []);

  const requestAccess = () => {
    apiCall("POST", RAISE_REQUEST, {
      user_email: account.username,
    })
      .then((res) => {
        setSentReq(true);
      })
      .catch((err) => {
        dispatch(addError("Failed to raise a request.Please try again."))
      });
  };

  return (
    <>
      <Grid
        item
        container
        direction="column"
        sx={{
          width: "100%",
          height: "100vh",
          marginTop: "50px",
        }}
        alignItems="center"
        justifyContent="center"
      >
        {sentReq ? (
          <>
            <Typography>You have requested access</Typography>
          </>
        ) : (
          <>
            <img
              src={accessdenied}
              alt="No access"
              width="300px"
              height="300px"
            />
            <Typography
              sx={{
                mt: 10,
                fontSize: "20px",
              }}
              color="primary"
              fontWeight="bolder"
            >
              {user.request === PENDING
                ? "You have requested access please wait!"
                : "Ooopps!! You donot have access."}
            </Typography>
            {!(user.request === PENDING) && (
              <Button
                sx={{
                  mt: 2,
                }}
                variant="contained"
                color="primary"
                onClick={requestAccess}
              >
                Request Access
              </Button>
            )}
          </>
        )}
      </Grid>
    </>
  );
};

export default NoAccess;
